import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enTranslations from "./locales/en.json";
import trTranslations from "./locales/tr.json";
import deTranslations from "./locales/de.json";
import frTranslations from "./locales/fr.json";
import esTranslations from "./locales/es.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      tr: {
        translation: trTranslations,
      },
      de: {
        translation: deTranslations,
      },
      fr: {
        translation: frTranslations,
      },
      es: {
        translation: esTranslations,
      },
    },
    fallbackLng: "en",
    load: "languageOnly", // tr-TR -> tr, en-US -> en şeklinde dönüştürür
    interpolation: {
      escapeValue: false,
    },
    detection: {
      // Algılama sırasını belirle: localStorage'ı querystring'den sonra kontrol et
      order: ['querystring', 'localStorage', 'navigator'],
      // localStorage'da saklanacak key
      lookupLocalStorage: 'i18nextLng',
      // Query string'de aranacak parametre
      lookupQuerystring: 'lng',
      // localStorage'a otomatik kaydetme
      caches: ['localStorage'],
    },
  });

export default i18n;
